export default __webpack_public_path__ + "static/media/Hilton Hotels and Resorts - Logo2.d61cfeb7.png";